module.exports = __webpack_public_path__ + "media/images/flags/32/Niue-2053183a9b65b5f43239c5a7005ca3a0.png";